import { Grid, Tooltip, Typography } from "@mui/material";
import CustomTable from "../Common/CustomTable";
import { PayloadReportType } from "../../types";
import { cellText } from "../Common/styles";

type PayloadResultTableProps = {
  data: PayloadReportType[];
  loading: boolean;
};

const PayloadResultTable: React.FC<PayloadResultTableProps> = ({ data, loading }) => {
  const columns = [
    {
      id: "key",
      label: "Parametre Adı",
      width: "30%",
      render: (row: PayloadReportType) => (
        <Tooltip title={row.key} placement="top" arrow>
          <Typography sx={cellText}>{row.key}</Typography>
        </Tooltip>
      ),
    },
    {
      id: "value",
      label: "Değer",
      width: "30%",
      render: (row: PayloadReportType) => (
        <Tooltip title={String(row.value ?? "")} placement="top" arrow>
          <Typography sx={cellText}>{String(row.value ?? "")}</Typography>
        </Tooltip>
      ),
    },
    {
      id: "description",
      label: "Açıklama",
      width: "40%",
      render: (row: PayloadReportType) => (
        <Tooltip title={row.description ?? ""} placement="top" arrow>
          <Typography sx={{ ...cellText, fontFamily: "inherit" }}>{row.description}</Typography>
        </Tooltip>
      ),
    },
  ];

  return (
    <Grid size={{ xs: 12, md: 6 }} sx={{ paddingBottom: 2, paddingLeft: { xs: 0, md: 2 } }}>
      <CustomTable
        columns={columns}
        data={data}
        totalCount={data.length}
        page={0}
        rowsPerPage={data.length}
        onPageChange={() => {}}
        onRowsPerPageChange={() => {}}
        loading={loading}
        maxHeight="600px"
        showActions={false}
        statusFunction={() => {}}
        isPagination={false}
      />
    </Grid>
  );
};

export default PayloadResultTable;
